var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.getText()),function(text,index){return [_c('render',{key:index,attrs:{"text":text}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }